<template>
  <avtalat-select  id="arendetyp" v-model:value="arendetyp" label="Ärendetyp">
    <option
      v-for="(item, index) in ArendetypOptions"
      :key="index"
      :value="item.id"
    >
      {{ item.label }}
    </option>
  </avtalat-select>
</template>

<script setup lang="ts">
import type { ArendeType } from "@/composables/KundserviceAppApiClient";
import { ArendetypOptions } from "@/common/constants";

const arendetyp = defineModel<ArendeType>();
</script>
